import { Select } from "@aclymatepackages/atoms";

import { carbonUnitTypes } from "../../helpers/otherHelpers";

const UnitsSelect = ({
  value = "",
  setValue,
  size = "small",
  label = "Unit",
  disabled,
}) => {
  return (
    <Select
      label={label}
      options={carbonUnitTypes.map(({ name, short }) => ({
        label: name,
        value: short,
      }))}
      value={value}
      editValue={setValue}
      size={size}
      disabled={disabled}
    />
  );
};
export default UnitsSelect;
